export default {
  acceptTermsRequired: 'कृपया नियम और शर्तें स्वीकार करें',
  accountNumber: 'खाता संख्या',
  acknowledgeText: 'स्वीकारें',
  acknowledgedText: 'स्वीकार किया',
  active: 'सक्रिय',
  activeBookings: 'सक्रिय बुकिंग',
  activeBucketsText: 'सक्रिय बकेट',
  activeToday: 'आज सक्रिय',
  adminRole: 'एडमिन — प्रबंध निदेशक',
  advance: 'अग्रिम',
  advancePaid: 'अग्रिम भुगतान',
  advancePaidLabel: 'अग्रिम',
  agreeTermsCheckbox: 'मैंने सभी नियम और शर्तें पढ़ी हैं और स्वीकार की हैं',
  agreement: 'नियम और समझौता',
  alertLog: 'अलर्ट लॉग',
  alertText: 'अलर्ट',
  alerts: 'ଆଲର୍ଟ',
  allAlerts: 'सभी चेतावनियाँ',
  allLoaded: 'सभी लोड',
  allMachinesOk: 'सभी मशीनें ठीक चल रही हैं।',
  allStats: 'पूर्ण आंकड़े',
  allowedText: 'अनुमत',
  amount: 'राशि',
  apiHealthTitle: 'API स्वास्थ्य',
  apiSloAlertsTitle: 'API SLO अलर्ट',
  appName: 'ଡେଭେଲପମେଣ୍ଟ ଏକ୍ସପ୍ରେସ',
  approvals: 'अनुमोदन',
  approveAndDispatch: 'स्वीकृत करें और मशीन भेजें',
  approved: 'स्वीकृत',
  assignedOperator: 'नियुक्त ऑपरेटर',
  attemptsLabel: 'प्रयास',
  attendance: 'उपस्थिति',
  auditLogs: 'ऑडिट लॉग्स',
  available: 'उपलब्ध',
  availableMachinery: 'उपलब्ध मशीनरी',
  availableNow: 'अभी उपलब्ध',
  avgRating: 'औसत रेटिंग',
  awaitingClientFeedback: 'क्लाइंट फीडबैक की प्रतीक्षा',
  awaitingDispatch: 'डिस्पैच की प्रतीक्षा',
  back: 'वापस जाएं',
  backToLogin: 'लॉगिन पर वापस जाएं',
  bank: 'बैंक',
  bankDetailsTitle: 'बैंक विवरण',
  baseAmount: 'मूल राशि',
  billingWallet: 'वॉलेट और बिलिंग',
  blacklistWarning: '⛔ ବ୍ଲାକଲିଷ୍ଟ ଚେତାବନୀ',
  blockedRateText: 'ब्लॉक दर',
  blockedText: 'ब्लॉक्ड',
  bookMachine: 'ମେସିନ ବୁକ୍ କରନ୍ତୁ',
  bookMachineAction: 'मशीन बुक करें',
  bookNow: 'अभी बुक करें',
  bookingConfirm: 'बुकिंग पुष्टि करें',
  bookingCostCalculator: 'बुकिंग और लागत कैलकुलेटर',
  bookingFailedGeneric: 'बुकिंग विफल। पुनः प्रयास करें।',
  bookingHistory: 'बुकिंग इतिहास',
  bookingReportTitle: 'बुकिंग रिपोर्ट',
  bookingScheduleSummary: 'दिन और महीने अनुसार बुकिंग शेड्यूल',
  bookingSelectMachineFirst: 'जारी रखने के लिए फ्लीट से मशीन चुनें।',
  bookingStepChoose: 'मशीन चुनें',
  bookingStepConfirm: 'पुष्टि और भुगतान',
  bookingStepCost: 'लागत और तारीख',
  bookingType: 'बुकिंग प्रकार चुनें',
  bookingTypeLabel: 'बुकिंग प्रकार',
  bookingTypeText: 'बुकिंग प्रकार',
  bookingsCount: '{count} बुकिंग',
  bookingsScheduleHint: 'क्लाइंट बुकिंग करने पर दिनवार शेड्यूल यहाँ दिखेगा।',
  burstText: 'बर्स्ट',
  busy: 'व्यस्त',
  callNow: 'अभी कॉल करें',
  cancel: 'रद्द करें',
  cancelAction: 'रद्द करें',
  cancelBooking: 'बुकिंग रद्द करें',
  cancelBookingPrompt: 'बुकिंग रद्द करें?',
  cancelPolicy: 'रद्दीकरण नीति',
  cancelText: 'ବାତିଲ',
  cancelWarning: 'क्या आप रद्द करना चाहते हैं?',
  changeLanguage: 'ଭାଷା ବଦଳାନ୍ତୁ',
  changeMachine: 'मशीन बदलें',
  changeMobileNumber: 'Change mobile number',
  chipAction: 'क्रिया',
  chipActor: 'कर्ता',
  chipEntity: 'एंटिटी',
  chipFrom: 'से',
  chipMeta: 'मेटा',
  chipRole: 'भूमिका',
  chipTo: 'तक',
  clearAll: 'सभी साफ करें',
  client: 'ग्राहक',
  clientFeedbackLabel: 'क्लाइंट फीडबैक',
  clientPortal: 'କ୍ଲାଇଣ୍ଟ ପୋର୍ଟାଲ',
  clientRatingsTitle: 'क्लाइंट रेटिंग और सुझाव',
  clientRole: 'क्लाइंट (ठेकेदार)',
  clients: 'ग्राहक',
  commission: 'कमीशन',
  commission15: 'कमीशन 15%',
  commissionPaid: 'कमीशन भुगतान',
  commissionRate: 'सकल बिलिंग का 15%',
  company: 'कंपनी',
  companyDetailsTitle: 'कंपनी विवरण',
  completeBookings: 'पूर्ण बुकिंग',
  completedBookings: 'पूर्ण बुकिंग',
  condition: 'स्थिति',
  confirm: 'ନିଶ୍ଚିତ କରନ୍ତୁ',
  confirmBooking: 'बुकिंग पुष्टि करें',
  confirmBookingAction: 'बुकिंग की पुष्टि करें',
  confirmCancel: 'रद्दीकरण पुष्टि करें',
  confirmPassword: 'Confirm password',
  confirmRetry: 'पुनः प्रयास की पुष्टि करें',
  contactCompany: 'डेवलपमेंट एक्सप्रेस से संपर्क करें',
  costCalculator: 'लागत कैलकुलेटर',
  crawlerNoRto: 'क्रॉलर (RTO नहीं)',
  currentlyDeployed: 'वर्तमान में तैनात',
  customAmount: 'कस्टम राशि (UPI/कार्ड ₹1 से)',
  cycles: "ଚକ୍ର",
  dailyWorkReport: 'दैनिक कार्य रिपोर्ट',
  dashboard: 'ଡ୍ୟାସବୋର୍ଡ',
  date: 'दिनांक',
  dayMachinesLabel: 'मशीनें',
  days: 'दिन',
  daysUnit: 'दिन',
  directContactBlacklist: 'सीधा संपर्क = ब्लैकलिस्ट',
  directContactProhibited: 'सीधा संपर्क सख्त वर्जित',
  directContactProhibitedText: 'सीधा संपर्क सख्त प्रतिबंधित',
  dispatched: 'भेजा गया',
  dlqMonitor: 'DLQ मॉनिटर',
  docChassisPlate: 'चेसिस / सीरियल प्लेट फोटो (RTO RC नहीं)',
  docEquipmentPhoto: 'पूर्ण मशीन फोटो (साइड व्यू)',
  docIdentity: 'PAN / आधार',
  docInsurance: 'बीमा प्रमाणपत्र',
  docInsuranceOptional: 'बीमा / उपकरण कवर (यदि उपलब्ध)',
  docMachineInvoice: 'मशीन खरीद / इनवॉइस',
  docPollution: 'प्रदूषण प्रमाणपत्र (PUC)',
  docRcBook: 'RC बुक (RTO पंजीकरण प्रमाणपत्र)',
  documentUploadTitle: 'दस्तावेज़ अपलोड',
  documents: 'दस्तावेज़ अपलोड',
  download: 'डाउनलोड',
  drawerMenu: 'मेनू',
  earnings: 'कमाई',
  email: 'ईमेल सहायता',
  emailAddress: 'ଇମେଲ ଠିକଣା',
  emailAddressLabel: 'ईमेल पता',
  expandBookingHint: 'पूरी बुकिंग, रद्द करें और ऑपरेटर रेटिंग के लिए नीचे महीना/दिन सेक्शन expand करें।',
  experience: 'अनुभव',
  exportCsv: 'CSV एक्सपोर्ट',
  failedText: 'असफल',
  feedbackAfterDispatch: 'मशीन डिस्पैच के बाद ऑपरेटर रेटिंग उपलब्ध होगी।',
  feedbackStatusAfterDispatch: 'डिस्पैच के बाद',
  feedbackStatusRateNow: 'ऑपरेटर रेट करें ↓',
  filterAll: 'सभी',
  filterCredit: 'क्रेडिट',
  filterDebit: 'डेबिट',
  filterCompleted: 'पूर्ण',
  filterCancelled: 'बंद',
  filterPending: 'लंबित',
  filterDisputed: 'विवादित',
  forgotPasswordChooseMethod: 'Choose email link or SMS OTP to reset your password.',
  forgotPasswordEmailDevHint: 'Local dev: open the API server terminal and copy the “Password reset link (development)” URL.',
  forgotPasswordEmailHint: 'Enter your registered admin email address.',
  forgotPasswordFailed: 'Could not send reset link. Please try again.',
  forgotPasswordIntro: 'We will email a secure reset link to your registered email address.',
  forgotPasswordInvalidEmail: 'Please enter a valid email address.',
  forgotPasswordInvalidOtp: 'Enter the 6-digit OTP from SMS.',
  forgotPasswordInvalidPhone: 'Please enter a valid 10-digit mobile number.',
  forgotPasswordLink: 'Forgot password?',
  forgotPasswordOtpSentTo: 'OTP sent to',
  forgotPasswordPhoneHint: 'Enter your registered mobile number. Reset link goes to the email on your account.',
  forgotPasswordSendOtp: 'Send OTP',
  forgotPasswordSending: 'Sending...',
  forgotPasswordSendingOtp: 'Sending OTP...',
  forgotPasswordSmsDevHint: 'SMS not configured in production yet — in development, check server logs for the OTP code.',
  forgotPasswordSmsFailed: 'Could not send OTP. Please try again.',
  forgotPasswordSmsHint: 'Enter your registered mobile number. A 6-digit OTP will be sent by SMS.',
  forgotPasswordSmsSuccess: 'If an account exists, OTP was sent to the registered mobile number.',
  forgotPasswordSubmit: 'Send reset link',
  forgotPasswordSuccess: 'If an account exists, reset instructions were sent to the registered email.',
  forgotPasswordTitle: 'Reset your password',
  formLabel: 'फॉर्म',
  fuel: 'ईंधन',
  fuelColon: 'ईंधन:',
  fuelHistoryTitle: 'ईंधन इतिहास',
  fuelLevel: 'ईंधन स्तर',
  fuelLevelUpdate: 'फ्यूल स्तर अपडेट',
  fuelNotePlaceholder: 'नोट: भरा / उपयोग ईंधन...',
  fullName: 'पूरा नाम',
  goBook: '→ मशीन बुक करें',
  gpsLiveLabel: '🟢 GPS लाइव',
  grandTotal: 'कुल योग',
  grandTotalText: 'कुल योग',
  gross: 'सकल',
  grossBilling: 'सकल बिलिंग',
  gst18: 'GST (18%)',
  gstInvoice: 'GST इनवॉइस',
  gstInvoices: 'GST इनवॉइस',
  gstin: 'GSTIN',
  hide: 'छुपाएं',
  highTrend: 'HIGH ट्रेंड',
  hitsText: 'हिट्स',
  hmrHrs: 'घंटे',
  hmrToday: 'आज का HMR',
  hmrTotal: 'कुल HMR',
  home: 'होम',
  hours: 'घंटे',
  hrsUnit: 'घंटे',
  idle: 'निष्क्रिय',
  ifsc: 'IFSC',
  ignition: 'इग्निशन',
  importantInfo: 'मशीन मालिकों के लिए महत्वपूर्ण जानकारी',
  instantCost: 'त्वरित लागत कैलकुलेटर',
  invoiceNotAvailableCancelled: 'इनवॉइस उपलब्ध नहीं (रद्द)',
  iot: 'IoT और GPS',
  issueReportTitle: 'समस्या रिपोर्ट',
  issueReportedSuccess: 'इश्यू यशस्वीरित्या नोंदवला!',
  issues: 'समस्याएं',
  joinUsAction: 'Join Us — मुफ्त रजिस्टर करें',
  joinUsBanner: 'मशीन किराए पर चाहिए?',
  joinUsHint: 'नए ग्राहक? JCB, excavator, crane बुक करने के लिए मुफ्त रजिस्टर करें।',
  landingCtaApp: 'Development Express खोलें',
  landingFeatBook: 'मिनटों में बुकिंग',
  landingFeatBookDesc: 'JCB, excavator, crane — live availability.',
  landingFeatPay: 'Wallet payments',
  landingFeatPayDesc: 'GST invoice, transparent billing.',
  landingFeatTrack: 'Live GPS',
  landingFeatTrackDesc: 'हर घंटे machine location पता करें।',
  landingHeroLine1: 'Smarter & Simpler.',
  landingHeroLine2: 'महाराष्ट्र का smart machinery rental.',
  landingSocialProof: 'महाराष्ट्र भर के builders और contractors जुड़े हैं।',
  landingStatMachines: 'मशीनें',
  landingStatRating: 'रेटिंग',
  landingTrustLine: 'Wallet-only · GST · Secured',
  lastRefreshed: 'अंतिम रिफ्रेश',
  live: 'लाइव',
  liveBookAvail: 'बुकिंग के बाद लाइव फीड उपलब्ध',
  liveCamera: '360° लाइव कैमरा — बुकिंग के बाद',
  liveMachineLocation: 'लाइव मशीन स्थान',
  liveText: 'लाइव',
  liveTracking: 'लाइव ट्रैकिंग',
  loadMoreAlerts: 'और अलर्ट लोड करें',
  loadMoreAttendance: 'और उपस्थिति लोड करें',
  loadMoreBookings: 'और बुकिंग लोड करें',
  loadMoreDlq: 'और DLQ लोड करें',
  loadMoreFuelLogs: 'और फ्यूल लॉग लोड करें',
  loadMoreLogs: 'और लॉग लोड करें',
  loadMoreMachines: 'और मशीनें लोड करें',
  loadMoreTransactions: 'और ट्रांजैक्शन लोड करें',
  loadMoreUsers: 'और यूजर्स लोड करें',
  loadedBookings: 'लोड की गई बुकिंग',
  loadedDlqItems: 'लोडेड DLQ आइटम',
  loadedFuelLogs: 'लोड किए गए फ्यूल लॉग',
  loadedOwnerBookings: '{count} मालिक बुकिंग लोड{suffix}',
  loading: 'लोड हो रहा है...',
  loadingDashboard: 'डैशबोर्ड लोड हो रहा है...',
  location: 'स्थान',
  lockConfirm: '🔒 लॉक पुष्टि करें',
  lockMachine: 'मशीन लॉक करें',
  lockWarning: 'Teltonika GPS के जरिए मशीन का इग्निशन दूर से बंद हो जाएगा।',
  locked: 'लॉक',
  loginAs: 'लॉगिन हो रहे हैं',
  loginChangeRole: 'भूमिका बदलें',
  loginClientPortalSubtitle: 'निर्माण मशीनरी बुक करने के लिए साइन इन करें',
  loginEmailHint: 'एडमिन लॉगिन के लिए रजिस्टर्ड ईमेल इस्तेमाल करें।',
  loginFailedGeneric: 'लॉगिन असफल — कृपया फिर से प्रयास करें',
  loginIAmQuestion: 'मैं कौन…?',
  loginModeOtp: 'OTP लॉगिन',
  loginModePassword: 'पासवर्ड',
  loginNewHereRegister: 'नए हैं? रजिस्टर करें',
  loginOtpDevHint: 'Development: SMS न हो तो server log में OTP देखें।',
  loginOtpHint: 'रजिस्टर्ड मोबाइल पर 6 अंकों का OTP भेजा जाएगा।',
  loginOtpSentTo: 'OTP भेजा:',
  loginOwnerPortalSubtitle: 'अपनी फ्लीट और पंजीकरण प्रबंधित करने के लिए साइन इन करें',
  loginPhoneHint: 'क्लाइंट, ओनर और ऑपरेटर लॉगिन के लिए रजिस्टर्ड मोबाइल नंबर इस्तेमाल करें।',
  loginPickRoleHint: 'पंजीकृत? भूमिका चुनें। नए हैं? नीचे Join Us।',
  loginPortalAdminSubtitle: 'प्लेटफ़ॉर्म नियंत्रण और अनुमोदन',
  loginPortalAdminTitle: 'एडमिन पोर्टल',
  loginPortalClientSubtitle: 'निर्माण मशीनरी बुक करने के लिए साइन इन',
  loginPortalClientTitle: 'क्लाइंट पोर्टल',
  loginPortalOperatorSubtitle: 'नियुक्त मशीन और दैनिक लॉग के लिए साइन इन',
  loginPortalOperatorTitle: 'ऑपरेटर पोर्टल',
  loginPortalOwnerSubtitle: 'फ्लीट और पंजीकरण प्रबंधित करने के लिए साइन इन',
  loginPortalOwnerTitle: 'मालिक पोर्टल',
  loginRoleAdminDesc: 'प्लेटफ़ॉर्म नियंत्रण, अनुमोदन और संचालन',
  loginRoleClientDesc: 'निर्माण परियोजनाओं के लिए मशीनरी बुक करें',
  loginRoleClientShort: 'क्लाइंट',
  loginRoleOperatorDesc: 'नियुक्त मशीन और दैनिक लॉग',
  loginRoleOwnerDesc: 'फ्लीट, कमाई और उपलब्धता प्रबंधित करें',
  loginRoleOwnerShort: 'ओनर',
  loginSendOtp: 'OTP भेजें',
  loginSendingOtp: 'OTP भेज रहे हैं...',
  loginSignInShort: 'साइन इन',
  loginTabOtp: 'OTP',
  loginTabPassword: 'पासवर्ड',
  loginVerifyOtp: 'Verify करें',
  loginVerifyingOtp: 'Verify हो रहा है...',
  logout: 'ଲଗଆଉଟ୍',
  sessionRevokedAlert: 'ଆପଣ ଅନ୍ୟ ଡିଭାଇସରେ ଲଗଇନ୍ ଅଛନ୍ତି। ଦୟାକରି ପୁନର୍ବାର ଲଗଇନ୍ କରନ୍ତୁ।',
  machine: 'मशीन',
  machineDefaultLabel: 'मशीन',
  machineDetails: 'मशीन और ऑपरेटर विवरण',
  machineDetailsTitle: 'मशीन विवरण',
  machineDispatchedAt: 'मशीन भेजी गई — {when}',
  machineHours: 'मशीन घंटे',
  machineIdLabel: 'मशीन ID',
  machineInfo: 'मशीन की जानकारी',
  machineLabel: 'मशीन',
  machineLog: 'मशीन लॉग',
  machineReg: 'मशीन पंजीकरण फॉर्म',
  machineRegistrationSubmitted: 'मशीन नोंदणी सबमिट झाली! DE टीम 24 तासांत पडताळणी करेल.',
  machineRegistrationTitle: 'मशीन पंजीकरण',
  machineStatus: 'मशीन स्थिति',
  machineStatusTitle: 'मशीन स्थिति',
  machines: 'मशीनें',
  marketingBackHome: 'वेबसाइट होम',
  marketingBadge: 'लाइव ऑपरेशन · कराड, सातारा',
  marketingBuiltFor: 'सटीकता, अनुपालन और गति चाहने वाली भारतीय निर्माण टीमों के लिए।',
  marketingCtaBook: 'मशीन बुक करें',
  marketingCtaLogin: 'Development Express खोलें — लॉगिन',
  marketingCtaWhatsApp: 'WhatsApp करें',
  marketingFooterRights: '2026 डेवलपमेंट एक्सप्रेस · कराड, सातारा',
  marketingHeadline: 'महाराष्ट्र का अग्रणी मशीनरी रेंटल प्लेटफॉर्म',
  marketingLead: 'रीयल-टाइम GPS, डिजिटल वॉलेट भुगतान, और निर्माण मशीनरी के लिए स्वचालित संचालन। 2011 से सेवा में।',
  marketingNavContact: 'संपर्क',
  marketingNavLogin: 'प्लेटफॉर्म लॉगिन →',
  marketingNavServices: 'सेवाएँ',
  marketingNavTech: 'प्रौद्योगिकी',
  marketingServicesTitle: 'हम क्या देते हैं',
  marketingStatDigital: 'डिजिटल भुगतान',
  marketingStatFleet: 'लाइव मशीनें',
  marketingStatYears: 'वर्षों का अनुभव',
  marketingSvcOps: 'पूर्ण संचालन सूट',
  marketingSvcOpsSub: 'मालिक, ऑपरेटर, क्लाइंट — एक प्लेटफॉर्म।',
  marketingSvcPay: 'केवल वॉलेट निपटान',
  marketingSvcPaySub: 'GST इनवॉइस — साइट पर नकद नहीं।',
  marketingSvcTrack: 'GPS और लाइव स्थिति',
  marketingSvcTrackSub: 'Teltonika से जुड़ी फ्लीट दृश्यता।',
  marketingTechLead: 'Development Express बुकिंग, अनुपालन और फील्ड टेलीमेट्री को एक ही वर्कफ़्लो में जोड़ता है।',
  md: 'MD',
  mediumTrend: 'MEDIUM ट्रेंड',
  minAdvanceRequired: 'न्यूनतम अग्रिम आवश्यक',
  minimumAdvance: 'न्यूनतम अग्रिम आवश्यक',
  minimumRecharge: 'UPI/कार्ड/QR के लिए न्यूनतम ₹1।',
  moUnit: 'महीने',
  mobileNumber: 'मोबाइल नंबर',
  monthMachineSummary: 'इस महीने की मशीनें',
  monthTotalLabel: 'महीने का कुल',
  months: 'महीने',
  moreAvailable: 'और उपलब्ध',
  myBookings: 'ମୋ ବୁକିଂ',
  myClientRating: 'मेरी क्लाइंट रेटिंग',
  myMachines: 'मेरी मशीनें',
  neftRtgs: 'NEFT/RTGS',
  netEarnedMonth: 'नेट कमाई (माह)',
  netPaid: 'नेट भुगतान',
  netPayable: 'शुद्ध देय',
  netReceived: 'नेट प्राप्त',
  netReceivedCaps: 'नेट प्राप्त',
  neverText: 'कभी नहीं',
  newBooking: 'नई बुकिंग',
  newClientRegister: 'नया क्लाइंट? यहां रजिस्टर करें',
  newClientRegistration: 'नया क्लाइंट पंजीकरण',
  newPassword: 'New password',
  nextText: 'आगे',
  noAlerts: 'कोई अलर्ट नहीं!',
  noAlertsNow: 'अभी कोई अलर्ट नहीं।',
  noBankRefund: '❌ बैंक रिफंड नहीं — केवल वॉलेट क्रेडिट',
  noBookings: 'कोई सक्रिय बुकिंग नहीं',
  noBookingsAccount: 'इस खाते के लिए अभी तक कोई बुकिंग नहीं।',
  noBookingsYet: 'अभी तक कोई बुकिंग नहीं',
  noClientFeedbackYet: 'अभी कोई क्लाइंट रेटिंग नहीं। डिस्पैच के बाद क्लाइंट फीडबैक यहाँ दिखेगा।',
  noDlqItems: 'कोई DLQ आइटम नहीं',
  noFileSelected: 'कोई फ़ाइल नहीं',
  noMachinesDashboard: 'अभी कोई मशीन नहीं। फ्लीट जोड़ने के लिए मशीन पंजीकरण करें।',
  noMachinesTrack: 'ट्रैक करने के लिए कोई मशीन नहीं',
  noMachinesTrackHint: 'GPS ट्रैकिंग के लिए मशीन पंजीकृत करें।',
  noMachinesYet: 'अभी कोई मशीन पंजीकृत नहीं',
  noMoreAuditLogs: 'वर्तमान फिल्टर के लिए और ऑडिट लॉग नहीं मिले।',
  noRecentApiSloBreach: 'हाल में कोई API SLO breach संकेत नहीं।',
  noRecentFailedLogins: 'हाल में कोई असफल लॉगिन प्रयास नहीं।',
  noRefund: 'नो रिफंड नीति',
  noSecuritySignalsFound: 'कोई सुरक्षा संकेत नहीं मिले।',
  noTransactionsFilter: 'चयनित फ़िल्टर के लिए कोई लेनदेन नहीं।',
  normalText: 'सामान्य',
  off: 'बंद',
  officeLabel: 'ऑफिस',
  on: 'चालू',
  operator: 'ऑपरेटर',
  operatorFeedbackColumn: 'ऑपरेटर फीडबैक',
  operatorFeedbackSaved: 'धन्यवाद! आपका फीडबैक सेव हो गया।',
  operatorFeedbackSubmitted: 'आपका फीडबैक',
  operatorFeedbackTitle: 'ऑपरेटर फीडबैक',
  operatorPortal: 'ଅପରେଟର ପୋର୍ଟାଲ',
  operatorRole: 'ऑपरेटर',
  operatorSatisfactionQuestion: 'क्या आप ऑपरेटर से संतुष्ट हैं?',
  operatorSuggestionPlaceholder: 'सुझाव या फीडबैक (वैकल्पिक)',
  operators: 'ऑपरेटर',
  optionalLabel: '(वैकल्पिक)',
  otpCode: 'OTP code',
  overview: 'अवलोकन',
  ownerBookingsAllLoaded: ' (सभी लोड)',
  ownerBookingsMoreAvailable: ' (और उपलब्ध)',
  ownerInfo: 'मालिक की जानकारी',
  ownerPortal: 'ମାଲିକ ପୋର୍ଟାଲ',
  ownerRole: 'मशीन मालिक',
  owners: 'मालिक',
  password: 'ପାସୱାର୍ଡ',
  passwordsMustMatch: 'Password and confirm password must match.',
  pastIssuesTitle: 'पिछली समस्याएं',
  payNow: 'अभी भुगतान करें',
  payNowText: 'अभी भुगतान करें',
  paymentBreakdownTitle: 'भुगतान विवरण — अप्रैल 2026',
  paymentCycle: 'भुगतान चक्र',
  paymentFailed: 'पेमेंट अयशस्वी! कृपया पुन्हा प्रयत्न करा.',
  paymentHistory: 'भुगतान इतिहास',
  paymentHistoryTitle: 'भुगतान इतिहास',
  paymentMethods: 'भुगतान के तरीके',
  paymentMode: 'भुगतान मोड',
  paymentSuccess: 'पेमेंट यशस्वी!',
  pdfInvoiceFailed: 'इनवॉइस PDF नहीं बन सका। पुनः प्रयास करें।',
  pdfReportFailed: 'रिपोर्ट PDF नहीं बन सका। पुनः प्रयास करें।',
  pdiCompleted: '✅ PDI / सुरक्षा निरीक्षण पूर्ण',
  pdiCrawlerHint: 'क्रॉलर: प्रदूषण (PUC) आवश्यक नहीं — RTO पंजीकृत नहीं।',
  pdiInfo: 'PDI निरीक्षण',
  pdiInsuranceApplicable: '✅ बीमा / कवर (यदि लागू)',
  pdiInsuranceValid: '✅ बीमा वैध और अद्यतन',
  pdiPollutionValid: '✅ प्रदूषण प्रमाणपत्र (PUC) वैध',
  pdiTitle: 'प्री-डिलीवरी निरीक्षण (PDI)',
  penaltyDeduct: 'रद्दीकरण दंड (1 घंटा)',
  pending: 'लंबित',
  pendingApproval: 'स्वीकृति लंबित',
  pendingCount: '{count} लंबित',
  pendingDispatch: 'डिस्पैच प्रतीक्षेत',
  perDay: 'प्रति दिन',
  perHour: 'प्रति घंटा',
  perMonth: 'प्रति माह',
  perWeek: 'प्रति सप्ताह',
  phone: 'फ़ोन',
  platform: 'ନିର୍ମାଣ ପରିଚାଳନା ପ୍ଲାଟଫର୍ମ',
  platformAgreement: 'प्लेटफॉर्म समझौता',
  policyLabel: 'नीति',
  policyTopicBooking: 'बुकिंग',
  policyTopicCancellation: 'रद्दीकरण',
  policyTopicContact: 'संपर्क',
  policyTopicGst: 'GST',
  policyTopicHours: 'सपोर्ट समय',
  portalBackLink: 'पोर्टल',
  portalClient: 'क्लाइंट',
  portalClientSub: 'मशीनरी बुक करें',
  portalNewClientRegister: 'नए क्लाइंट? रजिस्टर करें',
  portalNewOwnerRegister: 'नए ओनर? रजिस्टर करें',
  portalOwner: 'ओनर',
  portalOwnerSub: 'फ्लीट प्रबंधन',
  portalStaffAdmin: 'एडमिन',
  portalStaffOperator: 'ऑपरेटर',
  portalWelcome: 'स्वागत है',
  portalWelcomeHint: 'जारी रखने के लिए अपना पोर्टल चुनें',
  quantityLabel: 'मात्रा',
  quickIssueReport: 'त्वरित समस्या रिपोर्ट',
  quickRechargeUpi: 'UPI से त्वरित रिचार्ज',
  quickSelect: 'त्वरित चयन:',
  rateCard: 'दर पत्रक (ऑपरेटर सहित)',
  rateLimitTelemetryTitle: 'रेट लिमिट टेलीमेट्री',
  rateOperatorWork: 'ऑपरेटर का काम रेट करें (1–5 स्टार)',
  rating: 'रेटिंग',
  receiptId: 'रसीद ID',
  recentAlerts: 'हाल की चेतावनियाँ',
  recentFailedLoginsTitle: 'हाल की असफल लॉगिन',
  recentLabel: 'हाल का',
  recharge: 'ରିଚାର୍ଜ',
  rechargeFirst: '⚡ पहले वॉलेट रिचार्ज करें',
  rechargeWallet: '+ ୱାଲେଟ୍ ରିଚାର୍ଜ',
  ref: 'संदर्भ संख्या',
  refreshText: 'रिफ्रेश',
  refreshingText: 'रिफ्रेश हो रहा है...',
  regCapacitySpecs: 'क्षमता / विवरण',
  regDocCrawlerHint: 'क्रॉलर: चेसिस प्लेट, खरीद इनवॉइस, फोटो और ID। बीमा वैकल्पिक।',
  regDocWheeledHint: 'व्हील्ड: RC (RTO), बीमा, PUC और ID (अधिकतम 5MB प्रत्येक)।',
  regEquipmentCategory: 'उपकरण श्रेणी *',
  regFailed: 'पंजीकरण विफल। कृपया पुनः प्रयास करें।',
  regFileSizeError: 'प्रत्येक दस्तावेज़ अधिकतम 5MB',
  regFileTypeError: 'केवल PDF, JPG, PNG या WEBP अनुमत',
  regFleetIdOptional: 'फ्लीट / चेसिस ID (वैकल्पिक)',
  regMachineCategory: 'मशीन श्रेणी *',
  regMachineInfoTitle: 'मशीन जानकारी',
  regMachineIntro: 'केवल निर्माण heavy equipment — कोई ट्रक/ट्रांसपोर्ट नहीं। व्हील्ड (JCB 3DX) के लिए RTO; क्रॉलर (Poclain) साइट पर — RTO passing नहीं।',
  regMachineNameModel: 'मशीन नाम / मॉडल',
  regMobilityTracked: 'क्रॉलर',
  regMobilityTrackedHint: 'Poclain / chain excavator, dozer — साइट उपकरण, RTO passing नहीं',
  regMobilityWheeled: 'व्हील्ड',
  regMobilityWheeledHint: 'JCB 3DX, wheeled loader, grader — RTO (RC) वाला निर्माण उपकरण',
  machineFinancialSection: 'मशीन खरीद विवरण (वैकल्पिक)',
  machineOwnershipType: 'स्वामित्व प्रकार',
  machineOwnershipNew: 'नई मशीन',
  machineOwnershipUsed: 'ମୂଳ ମାଲିକ',
  machineOwnershipSecondHand: 'ପୂର୍ବ-ମାଲିକାନା',
  machinePurchasePrice: 'खरीद मूल्य (₹)',
  machinePurchasePriceHint: 'इस मशीन के लिए आपने जो राशि चुकाई',
  machinePurchaseDate: 'खरीद तिथि',
  machineYearOfManufacture: 'निर्माण वर्ष',
  machineLoanSection: 'इस मशीन पर मेरा loan है',
  machineLoanAmount: 'Loan राशि (₹)',
  machineLoanEmi: 'मासिक EMI (₹)',
  machineLoanTenure: 'Loan अवधि (महीने)',
  machineLoanStartDate: 'Loan शुरू तिथि',
  machineFuelConsumption: 'ईंधन खपत (L/hr)',
  machineMonthlyOperatingExpenses: 'ମାସିକ ପରିଚାଳନ ବ୍ୟୟ',
  machineOperatorMonthlySalary: 'ଅପରେଟର ମାସିକ ବେତନ',
  machineServiceMonthly: 'ସର୍ଭିସ / ରକ୍ଷଣାବେକ୍ଷଣ (ମାସିକ)',
  machineBreakdownMonthly: 'ବ୍ରେକଡାଉନ / ମରାମତି (ମାସିକ ହାରাହାରି)',
  machineMaterialsMonthly: 'ସାମଗ୍ରୀ / ଉପଭୋଗ୍ୟ (ମାସିକ)',
  recoveryPlan: 'ରିକଵରୀ ପ୍ଲାନ',
  recoveryOnTrack: 'ଠିକ ରାସ୍ତାରେ',
  recoveryNeedsAttention: 'ଧ୍ଯାନ ଦରକାର',
  recoveryActionRequired: 'କାର୍ଯ ଆବଶ୍ଯକ',
  recoveryAddPrice: 'ରିକଵରୀ ପ୍ଲାନ ଦେଖିବା ପାଇଂ କ୍ରଯ ମୂଲ୍ଯ ଯୋଡ଼ନ୍ତୁ',
  recoveryProgress: 'ନିବେଶ ପୁନରୁଦ୍ଧାର',
  recoveryDailyNet: 'ଦୈନିକ ନିଟ୍ ଆୟ',
  recoveryDays: 'ରିକଭରି ଅବଧି',
  recoveryProjectedDate: 'ଅନୁମାନିତ ରିକଭରି ତାରିଖ',
  recoveryRoi: 'ବାର୍ଷିକ ରିଟର୍ନ',
  recoveryCurrentValue: 'ବର୍ତ୍ତମାନ ମେସିନ ମୂଲ୍ୟ',
  editFinancialDetails: 'ଆର୍ଥିକ ବିବରଣୀ ସମ୍ପାଦନ କରନ୍ତୁ',
  financialDetailsSaved: 'ଆର୍ଥିକ ବିବରଣୀ ସଞ୍ଚୟ ହେଲା',
  recoveryBackfillNudge: 'ରିକଭରି ଟ୍ରାକିଂ ଅନଲକ୍ କରିବାକୁ {{count}} ମେସିନ(ଗୁଡ଼ିକ)ରେ କ୍ରୟ ବିବରଣୀ ଯୋଡ଼ନ୍ତୁ',
  dieselPriceTitle: 'ଡିଜେଲ୍ ମୂଲ୍ୟ',
  dieselPriceUpdate: 'ଡିଜେଲ୍ ମୂଲ୍ୟ ଅପଡେଟ୍ କରନ୍ତୁ',
  dieselPriceLatest: 'ସର୍ବନୂତନ ମୂଲ୍ୟ',
  dieselPriceNoRecord: 'ଡିଜେଲ୍ ମୂଲ୍ୟ ରେକର୍ଡ ନାହିଁ',
  dieselPricePerLitre: 'ଲିଟର୍ ମୂଲ୍ୟ (₹)',
  dieselQuantity: 'ଭରିଥିବା ପରିମାଣ (ଲିଟର)',
  dieselTaluka: 'ସହର / ଅଞ୍ଚଳ',
  bookingAttachment: 'ଆଟାଚ୍‌ମେଣ୍ଟ ବାଛନ୍ତୁ',
  bookingAttachmentNone: 'କୌଣସି ନିର୍ଦ୍ଦିଷ୍ଟ ଆଟାଚ୍‌ମେଣ୍ଟ ନାହିଁ',
  bookingWorkDescription: 'କାମ ବିବରଣୀ',
  bookingWorkDescriptionPlaceholder: 'ଯଥା ଭିତ୍ତି ଖନନ, ଟ୍ରେଞ୍ଚିଙ୍ଗ, ପାଇପ୍‌ଲାଇନ୍ କାମ',
  bookingAttachmentLabel: 'ଆଟାଚ୍‌ମେଣ୍ଟ',
  bookingSiteLabel: 'ସାଇଟ୍',
  bookingWorkLabel: 'କାମ',
  termsAccept: "ମୁଁ ନିୟମ ଓ ସର୍ତ୍ତାବଳୀ ସହ ସହମତ",
  termsRequired: "ପଞ୍ଜିକରଣ ପାଇଁ ନିୟମ ଓ ସର୍ତ୍ତାବଳୀ ଗ୍ରହଣ କରିବା ଆବଶ୍ୟକ",
  termsLink: "ନିୟମ ଓ ସର୍ତ୍ତାବଳୀ",
  clientBlacklisted: "ବ୍ଲାକଲିଷ୍ଟ",
  clientBlacklistReason: "ବ୍ଲାକଲିଷ୍ଟ କାରଣ",
  clientBlacklistConfirm: "ଏହି କ୍ଲାଏଣ୍ଟକୁ ବ୍ଲାକଲିଷ୍ଟ କରିବେ?",
  clientUnblacklist: "ବ୍ଲାକଲିଷ୍ଟରୁ ହଟାନ୍ତୁ",
  blacklistedClients: "ବ୍ଲାକଲିଷ୍ଟ କ୍ଲାଏଣ୍ଟ",
  blacklistedClientsEmpty: "କୌଣସି ବ୍ଲାକଲିଷ୍ଟ କ୍ଲାଏଣ୍ଟ ନାହିଁ",
  managerAccessRestricted: "ଫାଇନାନ୍ସ ଆକ୍ସେସ ପ୍ରତିବନ୍ଧିତ। ଓମ ଚଭାନଙ୍କ ସହ ଯୋଗାଯୋଗ କରନ୍ତୁ।",
  managerSection: "ମ୍ୟାନେଜର",
  managerAdd: "ମ୍ୟାନେଜର ଯୋଡନ୍ତୁ",
  managerName: "ମ୍ୟାନେଜର ନାମ",
  managerEmail: "ମ୍ୟାନେଜର ଇମେଲ୍",
  managerPassword: "ଅସ୍ଥାୟୀ ପାସୱାର୍ଡ",
  managerCreated: "ମ୍ୟାନେଜର ଆକାଉଣ୍ଟ ତିଆରି ହେଲା",
  managerCredentialsTitle: "ମ୍ୟାନେଜର ଲଗଇନ୍ ବିବରଣୀ",
  managerCredentialsSubtitle: "ଏହି ବିବରଣୀ ବର୍ତ୍ତମାନ ସଞ୍ଚୟ କରନ୍ତୁ — ପାସୱାର୍ଡ ପରେ ଫେରିପାଇବେ ନାହିଁ",
  managerCredentialsSaved: "ମୁଁ ବିବରଣୀ ସଞ୍ଚୟ କରିଛି",
  managerLoginUrl: "ଲଗଇନ୍ URL",
  managerActivity: "ମ୍ୟାନେଜର୍ କାର୍ଯ୍ୟକଳାପ",
  managerActivityEmpty: "ଏପର୍ଯ୍ୟନ୍ତ କୌଣସି କାର୍ଯ୍ୟକଳାପ ଲିପିବଦ୍ଧ ହୋଇନାହିଁ",
  managerActivityViewAll: "ସମସ୍ତ କାର୍ଯ୍ୟକଳାପ ଦେଖନ୍ତୁ",
  onboardingTitle: "ଆରମ୍ଭ କରନ୍ତୁ",
  onboardingAccountApproved: "ଆକାଉଣ୍ଟ ଅନୁମୋଦିତ",
  onboardingKycComplete: "KYC ଯାଞ୍ଚ ସମ୍ପୂର୍ଣ୍ଣ",
  onboardingKycPending: "KYC ଯାଞ୍ଚ ସମ୍ପୂର୍ଣ୍ଣ କରନ୍ତୁ",
  onboardingKycRejected: "KYC ପ୍ରତ୍ୟାଖ୍ୟାନ — ପୁନଃ ଦାଖଲ କରନ୍ତୁ",
  onboardingWalletFunded: "ୱାଲେଟରେ ବାଲାନ୍ସ ଅଛି",
  onboardingWalletEmpty: "ବୁକିଂ ପାଇଁ ୱାଲେଟ ବାଲାନ୍ସ ଯୋଡନ୍ତୁ",
  pushEnablePrompt: "ତୁରନ୍ତ ଅପଡେଟ୍ ପାଇଁ ପୁସ୍ ବିଜ୍ଞପ୍ତି ଚାଲୁ କରନ୍ତୁ",
  downloadDisputeStatement: "ବିବାଦ ବିବରଣୀ ଡାଉନଲୋଡ୍ କରନ୍ତୁ",
  downloadInvoice: "ଇନଭଏସ୍ ଡାଉନଲୋଡ୍ କରନ୍ତୁ",
  bookAgain: "ପୁନର୍ବାର ବୁକ୍ କରନ୍ତୁ",
  machineNoLongerAvailable: "ମେସିନ୍ ଆଉ ଉପଲବ୍ଧ ନାହିଁ",
  downloadHistoryPdf: "ଇତିହାସ PDF ଡାଉନଲୋଡ୍ କରନ୍ତୁ",
  onboardingFirstBooking: "ଆପଣଙ୍କ ପ୍ରଥମ ବୁକିଂ କରନ୍ତୁ",
  onboardingAllDone: "ଆପଣ ପ୍ରସ୍ତୁତ!",
  onboardingTrackerTitle: "ଅନବୋର୍ଡିଂ ପ୍ରଗତି",
  onboardingTrackerTarget: "ଅନବୋର୍ଡିଂ ଲକ୍ଷ୍ୟ: 48 ଘଣ୍ଟା",
  onboardingTrackerInProgress: "ଚାଲିଛି",
  onboardingTrackerActionRequired: "କାର୍ଯ୍ୟ ଆବଶ୍ୟକ",
  onboardingTrackerComplete: "ସମ୍ପୂର୍ଣ୍ଣ",
  onboardingTrackerPending: "ବିଚାରାଧୀନ",
  onboardingTrackerPhase1: "ପଞ୍ଜୀକରଣ",
  onboardingTrackerPhase2: "KYC ଯାଞ୍ଚ",
  onboardingTrackerPhase3: "ମେସିନ୍ ପଞ୍ଜୀକରଣ",
  onboardingTrackerPhase4: "ପ୍ରଥମ ବୁକିଂ ପ୍ରସ୍ତୁତ",
  onboardingTrackerHelper1: "ମେସିନ୍ ପଞ୍ଜୀକରଣ ଖୋଲିବାକୁ ଆଧାର + ସେଲଫି ଅପଲୋଡ୍ କରନ୍ତୁ",
  onboardingTrackerHelper2: "KYC ସମୀକ୍ଷାରେ — ସାଧାରଣତଃ 24 ଘଣ୍ଟା ମଧ୍ୟରେ",
  onboardingTrackerHelper3: "KYC ପ୍ରତ୍ୟାଖ୍ୟାନ — ଦଲିଲ ପୁନଃ ଦାଖଲ କରନ୍ତୁ",
  onboardingTrackerHelper4: "KYC ଅନୁମୋଦିତ — ଆପଣଙ୍କ ପ୍ରଥମ ମେସିନ୍ ଯୋଡନ୍ତୁ",
  onboardingTrackerHelper5: "ମେସିନ୍ ଆଡମିନ୍ ସମୀକ୍ଷାରେ",
  onboardingTrackerHelper6: "ମେସିନ୍ ଲାଇଭ୍ — ପ୍ରଥମ ବୁକିଂ ଅପେକ୍ଷା",
  onboardingTrackerPhaseLabel: "ପର୍ଯ୍ୟାୟ",
  alertsAndNotifications: 'ଆଲର୍ଟ ଏବଂ ବିଜ୍ଞପ୍ତି',
  dieselFuelCostPerHour: 'ଘଣ୍ଟା ପ୍ରତି ଇଞ୍ଧନ ଖର୍ଚ',
  dieselPercentOfRate: 'ଆପଣଙ୍କ ଘଣ୍ଟା ଦରର',
  dieselPriceSaved: 'ଡିଜେଲ୍ ମୂଲ୍ୟ ସଞ୍ଚୟ ହେଲା',
  dieselRateSuggestion: 'ଦର ପରାମର୍ଶ',
  dieselRateIncrease: 'ଡିଜେଲ୍ ବଢିଲା — ଦର ବଢାଇବା ବିଚାର କରନ୍ତୁ',
  dieselRateDecrease: 'ଡିଜେଲ୍ କମିଲା — ବୁକିଂ ପାଇଁ ଦର କମାନ୍ତୁ',
  dieselSuggestedRate: 'ପରାମର୍ଶିତ ଦର',
  dieselHistory: 'ମୂଲ୍ୟ ଇତିହାସ',
  dieselNoHistory: 'ଏପର୍ଯ୍ୟନ୍ତ ଡିଜେଲ୍ ମୂଲ୍ୟ ଇତିହାସ ନାହିଁ',
  dieselColDate: 'ତାରିଖ',
  dieselColPrice: 'ମୂଲ୍ୟ/ଲିଟର',
  dieselColQty: 'ପରିମାଣ',
  dieselColSource: 'ଉତ୍ସ',
  dieselUploadReceipt: 'ରସିଦ ଅପଲୋଡ୍',
  dieselExtractSuccess: 'ରସିଦରୁ ବାହାର କରାଗଲା',
  dieselExtractFailed: 'ବାହାର କରିହେଲା ନାହିଁ — ମାନୁଆଲ୍ ପ୍ରବେଶ କରନ୍ତୁ',
  applyRateSuggestion: '₹{{rate}}/ଘଣ୍ଟା ପ୍ରୟୋଗ କରନ୍ତୁ',
  rateSuggestionApplied: 'ଦର ସଫଳତାର ସହିତ ଅପଡେଟ୍ ହେଲା',
  marketPosition: 'ବଜାର ଅବସ୍ଥିତି',
  marketBelowMarket: 'ବଜାରରୁ କମ',
  marketCompetitive: 'ପ୍ରତିଯୋଗିତାମୂଲକ',
  marketAboveMarket: 'ବଜାରରୁ ଅଧିକ',
  marketNoData: 'ଆପଣଙ୍କ ଅଞ୍ଚଳ ପାଇଁ ଏପର୍ଯ୍ୟନ୍ତ ବଜାର ତଥ୍ୟ ନାହିଁ',
  marketSubmitRate: 'ବଜାର ଦର ଜମା କରନ୍ତୁ',
  marketCity: 'ସହର / ଅଞ୍ଚଳ',
  marketMinRate: 'ଆପଣଙ୍କ ଅଞ୍ଚଳରେ ସର୍ବନିମ୍ନ ଦର (₹/ଘଣ୍ଟା)',
  marketMaxRate: 'ଆପଣଙ୍କ ଅଞ୍ଚଳରେ ସର୍ବୋଚ୍ଚ ଦର (₹/ଘଣ୍ଟା)',
  marketRateSubmitted: 'ବଜାର ଦର ଜମା ହେଲା — ଧନ୍ୟବାଦ!',
  marketDataPoints: '{{count}} ଜମା ଉପରେ ଆଧାରିତ',
  marketRange: '{{city}} ରେ ବଜାର',
  marketSourceLocal: '{{city}} ଅଞ୍ଚଳ ରେଟ୍ ଉପରେ ଆଧାରିତ',
  marketSourcePlatform: 'ପ୍ଲାଟଫର୍ମ-ବ୍ୟାପୀ ରେଟ୍ ଉପରେ ଆଧାରିତ',
  regPremiumOnboarding: 'प्रीमियम ऑनबोर्डिंग',
  regRtoNumber: 'RTO पंजीकरण संख्या *',
  regSelectType: 'प्रकार चुनें…',
  regSubmitBtn: '✅ पंजीकरण जमा करें',
  regTagNoRto: 'RTO नहीं',
  regTagRto: 'RTO',
  regYearManufacture: 'निर्माण वर्ष *',
  register: 'मशीन पंजीकरण',
  registerAction: 'रजिस्टर करें',
  registerMachine: 'मशीन पंजीकरण',
  registering: 'रजिस्टर हो रहा है...',
  registrationPending: 'एडमिन 24 घंटे के भीतर आपका अकाउंट सक्रिय करेगा।',
  registrationSuccess: 'रजिस्ट्रेशन सफल!',
  remoteLockAlert: 'Teltonika GPS स्थापित होने के बाद रिमोट लॉक सक्षम होगा। DE सपोर्ट से संपर्क करें।',
  remoteLockMachine: '🔒 रिमोट लॉक मशीन',
  replaceFile: 'बदलें',
  reportText: 'रिपोर्ट',
  reports: 'ରିପୋର୍ଟ',
  resetMethodEmail: 'Email link',
  resetMethodSms: 'SMS OTP',
  resetPasswordFailed: 'Could not reset password. Request a new link.',
  resetPasswordIntro: 'Choose a strong password with at least 8 characters.',
  resetPasswordMinLength: 'Password must be at least 8 characters.',
  resetPasswordMissingToken: 'Reset link is missing or invalid. Use Forgot password from login.',
  resetPasswordSubmit: 'Update password',
  resetPasswordSuccess: 'Password updated. Redirecting to login...',
  resetPasswordTitle: 'Set new password',
  resetPasswordUpdating: 'Updating...',
  resetText: 'रीसेट',
  retryDlqItemTitle: 'DLQ आइटम पुनः प्रयास',
  retryFailedForDlq: 'DLQ आइटम के लिए पुनः प्रयास विफल',
  retryReasonAuditPlaceholder: 'पुनः प्रयास का कारण (ऑडिट हेतु)',
  retryText: 'पुनः प्रयास',
  revenue: 'राजस्व',
  running: 'चालू',
  satisfiedNo: 'संतुष्ट नहीं',
  satisfiedYes: 'हाँ, संतुष्ट',
  save: 'सहेजें',
  scanToPay: 'भुगतान के लिए स्कैन करें',
  scheduleColFeedback: 'फीडबैक',
  scheduleColQty: 'Qty',
  scheduleColTotal: 'कुल',
  scheduleColType: 'प्रकार',
  securitySignalsTitle: 'सुरक्षा संकेत',
  selectBook: 'यह मशीन बुक करें →',
  selectCalc: '📋 चुनें और लागत देखें →',
  selectFile: 'फ़ाइल चुनें',
  selectMachineFirst: 'पहले मशीन चुनें',
  selectQty: 'मात्रा चुनें',
  selectRole: 'ଭୂମିକା ବାଛନ୍ତୁ',
  selectedMachineText: 'चयनित मशीन',
  send: 'भेजें',
  sendEmail: 'ईमेल भेजें',
  sendWhatsapp: 'WhatsApp पर भेजें',
  settlements: 'निपटान',
  show: 'दिखाएं',
  signIn: 'ସାଇନ ଇନ୍',
  signingIn: 'ଲଗଇନ୍ ହେଉଛି...',
  signupCompanyName: 'कंपनी का नाम',
  signupContactName: 'संपर्क नाम',
  signupCreatePassword: 'पासवर्ड बनाएं',
  signupReenterPassword: 'पासवर्ड दोबारा दर्ज करें',
  signupSectionCompany: 'कंपनी',
  signupSectionContact: 'आपका विवरण',
  signupSectionSecurity: 'सुरक्षा',
  sinceExcellence: '2011 से · 15 वर्ष उत्कृष्टता',
  sinceLabel: 'से',
  sloBreachRisk: 'SLO breach जोखिम',
  sloHealthy: 'SLO स्वस्थ',
  speed: 'गति',
  staleText: 'पुराना',
  status: 'स्थिति',
  statusCancelled: 'रद्द',
  bookingClosed: 'ବନ୍ଦ',
  sectionNew: 'ନୂଆ',
  sectionAccepted: 'ସ୍ୱୀକୃତ',
  sectionActive: 'ସକ୍ରିୟ',
  sectionDispatched: 'ଡିସପାଚ',
  sectionCompleting: 'ସମ୍ପୂର୍ଣ୍ଣ ହେଉଛି',
  sectionDisputed: 'ବିବାଦ',
  sectionCompleted: 'ସମ୍ପୂର୍ଣ୍ଣ',
  sectionClosed: 'ବନ୍ଦ',
  statusCompleted: 'पूर्ण',
  stopped: 'बंद',
  submit: 'जमा करें',
  submitOperatorFeedback: 'फीडबैक भेजें',
  submittedRegistrations: 'जमा पंजीकरण',
  support: 'ସହାୟତା',
  supportPolicyBooking: 'केवल वॉलेट अग्रिम। साइट पर नकद नहीं।',
  supportPolicyCancellation: '1 घंटे का जुर्माना; शेष वॉलेट में।',
  supportPolicyContact: 'केवल DE सपोर्ट — सीधा ऑपरेटर संपर्क वर्जित।',
  supportPolicyGst: 'सभी इनवॉइस पर 18% GST; रिपोर्ट टैब से डाउनलोड।',
  supportPolicyHours: 'सोम–शनि, 9–7 IST',
  tableAtt: 'उप',
  tableChange: 'बदलाव',
  tableDay: 'दिन',
  tableEnd: 'समाप्त',
  tableHrs: 'घं',
  tableId: 'आईडी',
  tableIn: 'इन',
  tableLevel: 'स्तर',
  tableMonth: 'महीना',
  tableNote: 'नोट',
  tableOut: 'आउट',
  tableStart: 'शुरू',
  tagline: 'ଅବସ୍ଥାପନାର ସ୍ୱର୍ଣ୍ଣ ମାନ',
  tax: 'कर',
  tdsGstTcs: 'TDS 2% + GST TCS 1%',
  tdsTcs: 'TDS+TCS',
  termCommission: 'Development Express कमीशन: सकल बिलिंग का 15%',
  termFuel: 'मशीन में हमेशा 40%+ ईंधन रखें',
  termGps: 'GPS (Teltonika) अनिवार्य — DE द्वारा स्थापित',
  termGstTcs: 'GST TCS: GST नियमों के अनुसार 1%',
  termNoDirectContact: 'सीधा क्लाइंट संपर्क = तत्काल अनुबंध समाप्ति',
  termPaymentDays: 'क्लाइंट निपटान के 3 कार्य दिवसों में भुगतान',
  termTds: 'TDS कटौती: आयकर अधिनियम के अनुसार 2%',
  threeWorkingDays: '3 कार्य दिवस',
  timeLabel: 'समय',
  todayText: 'आज',
  topSourceIp: 'शीर्ष स्रोत IP',
  total: 'कुल',
  totalAdvanceLabel: 'अग्रिम भुगतान',
  totalBookingsText: 'कुल बुकिंग',
  totalMachines: 'कुल मशीनें',
  totalSpent: 'कुल खर्च',
  tracking: 'GPS ट्रैकिंग',
  transactionHistoryTitle: 'लेनदेन इतिहास',
  transactions: 'लेनदेन इतिहास',
  trustStatCompliant: 'अनुपालन',
  trustStatMachines: 'मशीन',
  trustStatRating: 'रेटिंग',
  txnDescription: 'विवरण',
  type: 'प्रकार',
  understood: '✅ समझ गया — प्लेटफॉर्म उपयोग करूंगा',
  understoodAction: 'समझ गया',
  unknownText: 'अज्ञात',
  updateFuel: 'फ्यूल अपडेट करें',
  updateText: 'अपडेट करें',
  upiAppsHint: 'PhonePe | GPay | Paytm | BHIM',
  uploadFile: 'अपलोड',
  valEmail: 'वैध ईमेल आवश्यक',
  valMachineName: 'मशीन नाम / मॉडल आवश्यक',
  valMachineType: 'उपकरण श्रेणी चुनें',
  valMobility: 'व्हील्ड या क्रॉलर उपकरण प्रकार चुनें',
  valOwnerName: 'मालिक का नाम आवश्यक',
  valPdiChecks: 'सभी आवश्यक जांचें पुष्टि करें',
  valPdiRequired: 'PDI पुष्टि आवश्यक',
  valPhone: 'वैध फ़ोन नंबर आवश्यक',
  valRto: 'व्हील्ड मशीनों के लिए RTO नंबर आवश्यक',
  valUploadMissing: 'अपलोड करें: {docs}',
  valYear: 'वैध वर्ष (YYYY) आवश्यक',
  viewMachines: '→ मशीनें देखें',
  wallet: 'ୱାଲେଟ୍',
  walletBalance: 'ୱାଲେଟ୍ ବ୍ୟାଲାନ୍ସ',
  walletCredit: 'वॉलेट क्रेडिट',
  walletDebit: 'वॉलेट डेबिट',
  walletDeduct: '50% अग्रिम वॉलेट से · नकद नहीं · काम पूर्ण होने पर GST चालान',
  walletInsufficient: '❌ अपर्याप्त',
  walletLowRecharge: 'वॉलेट शेष कम — अगली बुकिंग से पहले रिचार्ज करें',
  walletOnly: 'କେବଳ ୱାଲେଟ୍ · ନଗଦ ଗ୍ରହଣ ନୁହେଁ',
  walletOnlyPolicyDesc: 'सभी लेनदेन केवल वॉलेट से। नकद स्वीकार नहीं।',
  walletOnlyPolicyTitle: 'केवल वॉलेट नीति',
  walletRechargeTitle: 'वॉलेट रिचार्ज',
  walletSufficient: '✅ आगे बढ़ें',
  weeks: 'सप्ताह',
  whatsapp: 'WhatsApp',
  wksUnit: 'सप्ताह',
  year: 'वर्ष',
  yearsExperience: '{n} वर्ष',
  yourMessage: 'अपना प्रश्न या समस्या लिखें...',
  // --- Recent feature strings ---
  retryLabel: 'ପୁନଃ ପ୍ରୟାସ କରନ୍ତୁ',
  payrollPreview: 'ବେତନ ପୂର୍ବାବलୋକନ',
  payrollRun: 'ବେତନ ଚଲାନ୍ତୁ',
  payrollAlreadyRun: 'ଏହି ମାସ ପାଇଁ ବେତନ ପୂର୍ବରୁ ଚାଲିସାରିଛି',
  payrollGross: 'ମୋଟ ପ୍ରଦେୟ',
  payrollNet: 'ନିବ୍ବଳ ପ୍ରଦେୟ',
  payrollAdvanceDeducted: 'ଅଗ୍ରିମ କଟୌତି',
  payrollRunSuccess: 'ବେତନ ସଫଳତାର ସହ ଚାଲିଛି',
  payrollNoAmount: 'ଏହି ମାସ ପାଇଁ ପ୍ରଦେୟ ରାଶି ନାହିଁ',
  payrollMonth: 'ବେତନ ମାସ',
  exportPayrollCsv: 'ବେତନ CSV ରପ୍ତାନି',
  payrollExportMonth: 'ବେତନ ରପ୍ତାନି ମାସ',
  payrollDailyRate: 'ଦୈନିକ ହାର',
  payrollHistory: 'ବେତନ ଇତିହାସ',
  payrollNoHistory: 'ଏପର୍ଯ୍ୟନ୍ତ କୌଣସି ବେତନ ଚାଲିନାହିଁ',
  payrollColMonth: 'ମାସ',
  payrollColGross: 'ମୋଟ',
  payrollColDeduction: 'ଅଗ୍ରିମ କଟୌତି',
  payrollColNet: 'ନେଟ ବେତନ',
  payrollColDate: 'ତାରିଖ',
  downloadPayslip: 'ପେ ସ୍ଲିପ୍ ଡାଉନଲୋଡ୍',
  payslipTitle: 'ମାସିକ ପେ ସ୍ଲିପ୍',
  payslipEarnings: 'ଆୟ',
  payslipDeductions: 'କଟୌତି',
  payslipDaysWorked: 'କାମ ଦିନ',
  payslipGeneratedBy: 'Development Express ଦ୍ୱାରା ପ୍ରସ୍ତୁତ',
  operatorPayrollTitle: 'ମୋ ପଗାର',
  payrollMonthlySalary: 'ମାସିକ ପଗାର',
  payrollCurrentMonth: 'ଚାଲିତ ମାସ',
  payrollPreviousMonth: 'ପୂର୍ବ ମାସ',
  ownerAttendanceTitle: 'ଉପସ୍ଥିତି',
  ownerAttendanceEdit: 'ସମ୍ପାଦନ',
  ownerAttendanceSave: 'ସେଭ',
  ownerAttendanceNoRecords: 'ଏହି ମାସ ପାଇଁ ଉପସ୍ଥିତି ରେକର୍ଡ ନାହିଁ',
  ownerAttendanceOverrideSuccess: 'ଉପସ୍ଥିତି ଅପଡେଟ୍ ହେଲା',
  ownerSalaryUpdated: 'ପଗାର ସଫଳତାର ସହିତ ଅପଡେଟ୍ ହେଲା',
  ownerSalaryEditBtn: 'ପଗାର ସମ୍ପାଦନ',
  ownerSalaryNotSet: 'ପଗାର ସେଟ୍ ନାହିଁ — ପେରୋଲ୍ ପାଇଁ ପଗାର ସେଟ୍ କରନ୍ତୁ',
  duration: "ଅବଧି",
  durationLabel: 'ଅବଧି',
  plQuotaLabel: 'PL କୋଟା',
  plUsed: 'ବ୍ୟବହୃତ',
  plAllowed: 'ଅନୁମତ',
  plRemaining: 'ବାକି',
  plQuotaUpdated: 'PL କୋଟା ଅପଡେଟ୍',
  plQuotaExhausted: 'PL କୋଟା ଶେଷ — ଅବୈତନିକ ଛୁଟି ଭାବରେ ଚିହ୍ନିତ',
  plRemainingLabel: 'ବାକି PL',
  noAttendanceRecords: 'ଏପର୍ଯ୍ୟନ୍ତ ଉପସ୍ଥିତି ରେକର୍ଡ ନାହିଁ',
  noFuelLogs: 'ଏପର୍ଯ୍ୟନ୍ତ ଇଂଧନ ଲଗ୍ ନାହିଁ',
  noIssuesYet: 'ଏପର୍ଯ୍ୟନ୍ତ କୌଣସି ସମସ୍ୟା ରେକର୍ଡ ନାହିଁ',
  failedToLoad: 'ଡାଟା ଲୋଡ୍ କରିବାରେ ବିଫଳ',
  failedToLoadReport: 'ରିପୋର୍ଟ ଲୋଡ୍ କରିବାରେ ବିଫଳ',
  failedToLoadIssues: 'ସମସ୍ୟା ଲୋଡ୍ କରିବାରେ ବିଫଳ',
  failedToLoadAlerts: 'ସତର୍କତା ଲୋଡ୍ କରିବାରେ ବିଫଳ',
  noRecordsMonth: 'ଏହି ମାସ ପାଇଁ ରେକର୍ଡ ନାହିଁ',
  underReview: 'ସମୀକ୍ଷାଧୀନ',
  issueResolved: 'ସମାଧାନ ହୋଇଛି',
  presentDaysLabel: 'ଉପସ୍ଥିତ ଦିନ',
  halfDaysLabel: 'ଅଧା ଦିନ',
  absentDaysLabel: 'ଅନୁପସ୍ଥିତ ଦିନ',
  totalHmrLabel: 'ମୋଟ HMR',
  noActiveBookingIdle: 'କୌଣସି ସକ୍ରିୟ ବୁକିଂ ନାହିଁ — ମେସିନ୍ ନିଷ୍କ୍ରିୟ',
  siteLocationNotCaptured: 'ସାଇଟ୍ ସ୍ଥାନ ରେକର୍ଡ ହୋଇନାହିଁ',
  siteLocationNotAvailable: 'ସାଇଟ୍ ସ୍ଥାନ ଉପଲବ୍ଧ ନାହିଁ',
  bookingRefLabel: 'ବୁକିଂ Ref',
  alertPendingBookings: 'ବାକି ବୁକିଂ',
  alertPendingPayouts: 'ବାକି ପେମେଣ୍ଟ',
  alertLowFuel: 'କମ୍ ଇଂଧନ',
  alertOpenIssues: 'ଖୋଲା ସମସ୍ୟା',
  noMachineRunning: 'ବର୍ତ୍ତମାନ କୌଣସି ମେସିନ୍ ଚାଲୁନାହିଁ',
  trackingEmptyHint: 'ମେସିନ୍ ପଠାଯିବା ପରେ ଆପଣଙ୍କ ସକ୍ରିୟ ବୁକିଂ ଏଠାରେ ଦେଖାଯିବ।',
  trackingUpdatedEvery5s: 'ପ୍ରତି 5 ସେକେଣ୍ଡରେ ଅପଡେଟ୍',
  fuelLastOperatorUpdate: '(ଶେଷ ଅପରେଟର୍ ଅପଡେଟ୍)',
  alertExtensionPending: 'ବୁକିଂ ବିସ୍ତାର ବିଚାରାଧୀନ',
  alertConfirmCompletion: 'ଦୟାକରି କାମ ସମାପ୍ତି ନିଶ୍ଚିତ କରନ୍ତୁ',
  alertWalletCredited: 'ୱାଲେଟକୁ ଯୋଡାଗଲା',
  alertFeedbackRequest: 'କାମ ସମାପ୍ତ — ଆପଣଙ୍କ ମତାମତ ଦିଅନ୍ତୁ',
  noLogsYet: 'ଏପର୍ଯ୍ୟନ୍ତ କୌଣସି କାର୍ଯ୍ୟକଳାପ ଲଗ ହୋଇନାହିଁ',
  todayActivityLog: 'ଆଜିର କାର୍ଯ୍ୟକଳାପ ଲଗ',
  machineLogSubtitle: 'ଇନ୍ଧନ, ଉପସ୍ଥିତି, ସମସ୍ୟା — ସ୍ଥାନୀୟ ସେସନ୍ ଲଗ',
  timerPaused: 'Timer ବନ୍ଦ',
  liveBookingTitle: 'ଲାଇଭ୍ ବୁକିଂ',
  machineLogTimerHint: 'Timer Admin ଆରମ୍ଭ କରନ୍ତି। ନିମ୍ନରେ ଆପଣଙ୍କ ପ୍ରକୃତ କାମ ସମୟ ଲେଖନ୍ତୁ — ଶେଷରେ Mark Work Complete କ୍ଲିକ୍ କରନ୍ତୁ।',
  resumeTimer: 'Resume Timer',
  pauseTimer: 'Pause Timer',
  attendanceLogNote: 'ଉପସ୍ଥିତି',
  ownerAlertBookingPending: 'ନୂତନ ବୁକିଂ ଆପଣଙ୍କ ଅନୁମୋଦନ ପାଇଁ ବିଚାରାଧୀନ —',
  ownerAlertBookingHours: 'ଘଣ୍ଟା',
  ownerAlertPayoutPending: '₹{{amount}} ପେମେଣ୍ଟ ସ୍ଥାନାନ୍ତର ବିଚାରାଧୀନ',
  ownerAlertFuelLow: 'ଇନ୍ଧନ କମ',
  ownerAlertFuelRemaining: 'ବାକି',
  ownerAlertIssue: 'ସମସ୍ୟା ଲେଖାଗଲା',
  iotGpsDevicesActive: 'GPS ଉପକରଣ ସକ୍ରିୟ',
  iotDashcamsOnline: 'ଡ୍ୟାସକ୍ୟାମ ଅନଲାଇନ୍',
  iotFuelSensorsActive: 'ଇନ୍ଧନ ସେନ୍ସର ସକ୍ରିୟ',
  iotMachinesLocked: 'ମେସିନ ଲକ୍',
  iotDeviceStatus: 'IoT ଉପକରଣ ସ୍ଥିତି',
  iotColMachine: 'ମେସିନ',
  iotColGps: 'GPS',
  iotColLocation: 'ଅବସ୍ଥାନ',
  iotColFuel: 'ଇନ୍ଧନ %',
  iotColDashcam: 'ଡ୍ୟାସକ୍ୟାମ',
  iotColIgnition: 'ଇଗ୍ନିସନ୍',
  iotColAction: 'କାର୍ଯ୍ୟ',
  iotStatusOnline: 'ଅନଲାଇନ୍',
  iotStatusNotConnected: 'ସଂଯୁକ୍ତ ନୁହେଁ',
  iotStatusLive: 'ଲାଇଭ୍',
  iotStatusOn: 'ON',
  iotStatusOff: 'OFF',
  iotLockBtn: 'ଲକ୍',
  iotNotConnectedBanner: 'IoT ହାର୍ଡୱେର୍ ଏପର୍ଯ୍ୟନ୍ତ ସ୍ଥାପିତ ହୋଇନାହିଁ। Teltonika ଉପକରଣ ସ୍ଥାପନା ପରେ GPS, ଡ୍ୟାସକ୍ୟାମ ଏବଂ ରିମୋଟ୍ ଲକ୍ ସୁବିଧା ଉପଲବ୍ଧ ହେବ।',
  fuelUpdateTitle: 'ଇନ୍ଧନ ଅପଡେଟ୍',
  fuelSensorAccuracyNote: 'ଅପରେଟର ଲଗ୍ କରିଥିବା ଇନ୍ଧନ ସ୍ତର · ମାନୁଆଲ୍ ଏଣ୍ଟ୍ରି',
  bookingsTab: 'ବୁକିଂ',
  unknownLabel: 'ଅଜ୍ଞାତ',
  naLabel: 'N/A',
  baseLabel: 'ଆଧାର',
  qtyLabel: 'ପରିମାଣ',
  actualHrsLabel: 'ପ୍ରକୃତ ଘଣ୍ଟା',
  auditStatTotal: 'ମୋଟ',
  auditStatSecurity: 'ସୁରକ୍ଷା',
  auditStatActors: 'କର୍ତ୍ତା',
  auditStatAdmin: 'Admin',
  auditStatNonAdmin: 'Non-Admin',
  kycDocLicense: 'ଲାଇସେନ୍ସ',
  kycDocAadhaarFront: 'Aadhaar ସାମ୍ନା',
  kycDocAadhaarBack: 'Aadhaar ପଛ',
  kycDocPoliceVerification: 'ପୋଲିସ ଯାଞ୍ଚ',
  kycVerification: 'KYC ଯାଞ୍ଚ',
  kycNotSubmitted: 'KYC ଦାଖଲ ହୋଇନି',
  kycUnderReview: 'KYC ସମୀକ୍ଷାରେ',
  kycVerified: 'KYC ଯାଞ୍ଚିତ',
  kycRejected: 'KYC ପ୍ରତ୍ୟାଖ୍ୟାତ',
  kycAadhaarFront: 'Aadhaar ସାମ୍ନା',
  kycAadhaarBack: 'Aadhaar ପଛ',
  kycSelfie: 'ସେଲ୍ଫି',
  kycSubmitBtn: 'KYC ଡକ୍ୟୁମେଣ୍ଟ ଦାଖଲ କରନ୍ତୁ',
  kycSubmitSuccess: 'ଡକ୍ୟୁମେଣ୍ଟ ଦାଖଲ — ସମୀକ୍ଷାରେ',
  kycResubmit: 'ପୁନର୍ବାର ଡକ୍ୟୁମେଣ୍ଟ ଦାଖଲ କରନ୍ତୁ',
  adminKycTitle: 'କ୍ଲାଏଣ୍ଟ KYC ସମୀକ୍ଷା',
  adminKycAllFilter: 'ସବୁ',
  adminKycNoSubmissions: 'ଏପର୍ଯ୍ୟନ୍ତ KYC ଦାଖଲ ନାହିଁ',
  adminOwnerKycTitle: 'ମାଲିକ KYC ସମୀକ୍ଷା',
  adminOwnerKycNoSubmissions: 'ଏପର୍ଯ୍ୟନ୍ତ ମାଲିକ KYC ଦାଖଲ ନାହିଁ',
  adminOperatorKycTitle: 'ଅପରେଟର KYC ସମୀକ୍ଷା',
  adminOperatorKycNoSubmissions: 'ଏପର୍ଯ୍ୟନ୍ତ ଅପରେଟର KYC ଦାଖଲ ନାହିଁ',
  kycRejectedWarning: 'ଆପଣଙ୍କ KYC ପ୍ରତ୍ୟାଖ୍ୟାନ ହୋଇଛି। ଦୟାକରି ଦସ୍ତାବିଜ ପୁନର୍ବାର ଦାଖଲ କରନ୍ତୁ।',
  kycNotSubmittedHint: 'ବିଶ୍ୱାସଯୋଗ୍ୟ ଅଭିଜ୍ଞତା ପାଇଁ KYC ସମ୍ପୂର୍ଣ୍ଣ କରନ୍ତୁ।',
  kycPendingHint: 'ଆପଣଙ୍କ KYC ସମୀକ୍ଷାଧୀନ।',
  kycGoToTab: 'KYC କୁ ଯାଆନ୍ତୁ',
  adminKycApproveBtn: 'ଅନୁମୋଦନ',
  adminKycRejectBtn: 'ପ୍ରତ୍ୟାଖ୍ୟାନ',
  adminKycViewDocs: 'ଡକ୍ୟୁମେଣ୍ଟ ଦେଖନ୍ତୁ',
  adminKycRejectReason: 'ପ୍ରତ୍ୟାଖ୍ୟାନର କାରଣ',
  adminKycRereviewBtn: 'ପୁନର୍ବାର ସମୀକ୍ଷା',
  kycPan: 'PAN କାର୍ଡ',
  kycOwnerSubmitSuccess: 'ଦସ୍ତାବିଜ ଜମା — ଆପଣଙ୍କ KYC ସମୀକ୍ଷାଧୀନ',
  kycLicense: 'ଡ୍ରାଇଭିଂ ଲାଇସେନ୍ସ',
  kycPoliceVerification: 'ପୋଲିସ ଯାଞ୍ଚ',
  kycOperatorSubmitSuccess: 'ଦସ୍ତାବିଜ ଜମା — ଆପଣଙ୍କ KYC ସମୀକ୍ଷାଧୀନ',
  operatorKycRejectedAssign: 'ଏହି ଅପରେଟରଙ୍କ KYC ପ୍ରତ୍ୟାଖ୍ୟାନ ହୋଇଛି — ପୁନର୍ବାର ଅନୁମୋଦିତ ନହେବା ପର୍ଯ୍ୟନ୍ତ ସେମାନଙ୍କୁ ନିୟୋଜିତ କରାଯାଇ ପାରିବ ନାହିଁ।',
  operatorsColOperator: 'ଅପରେଟର',
  operatorsColEmail: 'ଇମେଲ',
  operatorsColPhone: 'ଫୋନ',
  operatorsColDocuments: 'ଦଲିଲ',
  operatorsColStatus: 'ସ୍ଥିତି',
  operatorsDocumentsBtn: 'ଦଲିଲ ({{count}})',
  operatorsNoResults: 'କୌଣସି ଅପରେଟର ମିଳିଲା ନାହିଁ',
  operatorsAllTitle: 'ସମସ୍ତ ଅପରେଟର ({{count}})',
  operatorsKycDialogDesc: 'KYC ଦଲିଲ',
  bookingsCountLabel: '{{count}} ବୁକିଂ',
  complianceDates: 'ଅନୁପାଲନ ତାରିଖ',
  complianceInsurance: 'ବୀମା',
  complianceRcBook: 'RC ବହି',
  compliancePuc: 'PUC',
  complianceNotSet: 'ସେଟ ନାହିଁ',
  complianceExpired: 'ମেয়াদ ଶେଷ',
  complianceExpiringSoon: 'ଶୀଘ୍ର ମেয়াদ ଶେଷ',
  complianceExpiringCritical: '7 ଦିନରେ ମেয়াদ',
  complianceValid: 'ବୈଧ',
  complianceUpdateBtn: 'ଅନୁପାଲନ ତାରିଖ ଅପଡେଟ୍ କରନ୍ତୁ',
  complianceSaveBtn: 'ସେଭ୍',
  complianceAlertsTitle: 'ଅନୁପାଲନ ସତର୍କତା',
  complianceAllCompliant: 'ସମସ୍ତ ମେସିନ୍ ଅନୁପାଲନରେ ✅',
  complianceColMachine: 'ମେସିନ୍',
  complianceColOwner: 'ମାଲିକ',
  complianceColInsurance: 'ବୀମା',
  complianceColRcBook: 'RC ବହି',
  complianceColPuc: 'PUC',
  complianceNa: 'N/A',
  complianceStartDate: 'ଆରମ୍ଭ ତାରିଖ',
  complianceEndDate: 'ଶେଷ ତାରିଖ',
  complianceExtractBtn: 'ତାରିଖ ସ୍ୱୟଂ ଭରିବା ପାଇଁ ଡକ୍ୟୁମେଣ୍ଟ ଅପଲୋଡ୍ କରନ୍ତୁ',
  complianceExtractSuccess: 'ତାରିଖ ବାହାର କରାଗଲା — ସେଭ୍ କରିବା ପୂର୍ବରୁ ଯାଞ୍ଚ କରନ୍ତୁ',
  complianceExtractError: 'ତାରିଖ ବାହାର କରିପାରିଲେ ନାହିଁ — ଦୟାକରି ମାନୁଆଲ୍ ଲେଖନ୍ତୁ',
  complianceExtracting: 'ଡକ୍ୟୁମେଣ୍ଟ ପଢ଼ୁଛି...',
  serviceHistory: 'ସେବା ଇତିହାସ',
  serviceLastService: 'ଶେଷ ସେବା',
  serviceNoRecords: 'ଏପର୍ଯ୍ୟନ୍ତ କୌଣସି ସେବା ରେକର୍ଡ ନାହିଁ',
  serviceNextDue: 'ପରବର୍ତ୍ତୀ ସେବା ବାକି',
  serviceNextHmr: 'ପରବର୍ତ୍ତୀ ସେବାରେ',
  serviceAddLog: 'ସେବା ଲଗ୍ ଯୋଡ଼ନ୍ତୁ',
  serviceDate: 'ସେବା ତାରିଖ',
  serviceType: 'ସେବା ପ୍ରକାର',
  serviceHmr: 'ସେବା HMR',
  serviceNextDate: 'ପରବର୍ତ୍ତୀ ସେବା ତାରିଖ',
  serviceWorkDone: 'କରାଯାଇଥିବା କାମ',
  serviceNotes: 'ନୋଟ',
  serviceTypeRoutine: 'ନିୟମିତ',
  serviceTypeMajor: 'ପ୍ରଧାନ',
  serviceTypeBreakdown: 'ବିଫଳ',
  serviceTypePdi: 'PDI',
  serviceTypeOther: 'ଅନ୍ୟ',
  serviceOverdue: 'ମেয়াদ ଅତିକ୍ରମ',
  serviceDueSoon: 'ଶୀଘ୍ର ବାକି',
  fleetAnalytics: 'ଫ୍ଲିଟ୍ ବିଶ୍ଳେଷଣ',
  analyticsRevenue: 'ମୋଟ ଆୟ',
  analyticsBookings: 'ମୋଟ ବୁକିଂ',
  analyticsHours: 'ମୋଟ ଘଣ୍ଟା',
  analyticsActiveMachines: 'ସକ୍ରିୟ ମେସିନ',
  analyticsMonthlyTrend: 'ମାସିକ ଆୟ ପ୍ରବୃତ୍ତି',
  analyticsMachineTable: 'ମେସିନ୍ ଅନୁଯାୟୀ ଆୟ',
  analyticsNoData: 'ଏହି ଅବଧିରେ କୌଣସି ସମ୍ପୂର୍ଣ୍ଣ ବୁକିଂ ନାହିଁ',
  analyticsLastBooking: 'ଶେଷ ବୁକିଂ',
  analytics3Months: '3 ମାସ',
  analytics6Months: '6 ମାସ',
  analytics12Months: '12 ମାସ',
  adminAnalytics: 'ବିଶ୍ଳେଷଣ',
  adminFleetTitle: 'ଫ୍ଲିଟ୍ ବିଶ୍ଳେଷଣ',
  adminFleetPlatformRevenue: 'ପ୍ଲାଟଫର୍ମ ଆୟ',
  adminFleetActiveOwners: 'ସକ୍ରିୟ ମାଲିକ',
  adminFleetOwnerCol: 'ମାଲିକ',
  adminFleetMonthlyTrend: 'ମାସିକ ଆୟ ପ୍ରବୃତ୍ତି',
  adminFleetMachineTable: 'ମେସିନ୍ ଅନୁସାରେ ଆୟ',
  adminFleetNoData: 'ଏହି ଅବଧିରେ କୌଣସି ସମ୍ପୂର୍ଣ୍ଣ ବୁକିଂ ନାହିଁ',
  adminFinancialIntelligence: 'ମେସିନ ଆର୍ଥିକ ବୁଦ୍ଧି',
  adminTotalInvested: 'ମୋଟ ନିବେଶ',
  adminTotalEarned: 'ମୋଟ ଆୟ',
  adminAvgRecovery: 'ହାରାହାରି ପୁନରୁଦ୍ଧାର',
  adminBreakEvenRate: 'ବ୍ରେକ୍-ଇଭେନ୍ ହାର',
  adminProfitMargin: 'ଲାଭ ମାର୍ଜିନ',
  adminNoFinancialData: 'ଏପର୍ଯ୍ୟନ୍ତ ଆର୍ଥିକ ତଥ୍ୟ ଥିବା ମେସିନ ନାହିଁ',
  adminMachineDetail: 'ମେସିନ ବିବରଣୀ',
  adminCallOwner: 'ମାଲିକଙ୍କୁ କଲ୍ କରନ୍ତୁ',
  adminWhatsappOwner: 'WhatsApp ମାଲିକ',
  adminMarketRates: 'ମାର୍କେଟ୍ ରେଟ୍ ଜମା',
  adminMarketRateDelete: 'ଡିଲିଟ୍',
  adminMarketRateDeleteConfirm: 'ଏହି ମାର୍କେଟ୍ ରେଟ୍ ଜମା ଡିଲିଟ୍ କରିବେ?',
  adminMarketRateDeleted: 'ମାର୍କେଟ୍ ରେଟ୍ ଡିଲିଟ୍ ହେଲା',
  adminMarketRateNoData: 'ଏପର୍ଯ୍ୟନ୍ତ କୌଣସି ମାର୍କେଟ୍ ରେଟ୍ ଜମା ନାହିଁ',
  marketRateApprove: 'ଅନୁମୋଦନ କରନ୍ତୁ',
  marketRateReject: 'ପ୍ରତ୍ୟାଖ୍ୟାନ କରନ୍ତୁ',
  marketRateApproved: 'ଅନୁମୋଦିତ',
  marketRateRejected: 'ପ୍ରତ୍ୟାଖ୍ୟାତ',
  marketRatePending: 'ବିଚାରାଧୀନ',
  marketRateReviewed: 'ମାର୍କେଟ୍ ରେଟ୍ ସମୀକ୍ଷା ହୋଇଛି',
  marketRatePendingReview: 'ଆପଣଙ୍କ ରେଟ୍ ଜମା ହୋଇଛି ଏବଂ ଆଡମିନ୍ ସମୀକ୍ଷା ପାଇଁ ବିଚାରାଧୀନ ଅଛି।',
  marketRateEditApprove: 'ସମ୍ପାଦନ ଏବଂ ଅନୁମୋଦନ',
  marketRateEditMin: 'ସଂଶୋଧିତ ସର୍ବନିମ୍ନ ରେଟ୍ (₹/ଘଣ୍ଟା)',
  marketRateEditMax: 'ସଂଶୋଧିତ ସର୍ବାଧିକ ରେଟ୍ (₹/ଘଣ୍ଟା)',
  adminPayrollOverview: 'ବେତନ ସମୀକ୍ଷା',
  adminPayrollTotalOperators: 'ମୋଟ ଅପରେଟର',
  adminPayrollTotalGross: 'ମୋଟ ଦେୟ',
  adminPayrollTotalNet: 'ମୋଟ ନେଟ ଦେୟ',
  adminPayrollNoData: 'ଏହି ମାସ ପାଇଁ ବେତନ ତଥ୍ୟ ନାହିଁ',
  subTabSchedule: 'ସମୟସୂଚୀ',
  subTabHistory: 'ଇତିହାସ',
  subTabAnalytics: 'ବିଶ୍ଳେଷଣ',
  clientAnalyticsTitle: 'ବୁକିଂ ବିଶ୍ଳେଷଣ',
  clientAnalyticsSpend: 'ମୋଟ ଖର୍ଚ୍ଚ',
  clientAnalyticsHours: 'ମୋଟ ଘଣ୍ଟା',
  clientAnalyticsBookings: 'ସମ୍ପୂର୍ଣ୍ଣ ବୁକିଂ',
  clientAnalyticsMachines: 'ବ୍ୟବହୃତ ମେସିନ୍',
  clientAnalyticsAvgSpend: 'ପ୍ରତି ବୁକିଂ ହାରାହାରି',
  clientAnalyticsMonthlyTrend: 'ମାସିକ ଖର୍ଚ୍ଚ ପ୍ରବୃତ୍ତି',
  clientAnalyticsTopMachines: 'ଶୀର୍ଷ ମେସିନ୍',
  clientAnalyticsNoData: 'ଏହି ଅବଧିରେ କୌଣସି ସମ୍ପୂର୍ଣ୍ଣ ବୁକିଂ ନାହିଁ',
  operatorAnalyticsTitle: 'କାମ ବିଶ୍ଳେଷଣ',
  operatorAnalyticsPresentDays: 'ଉପସ୍ଥିତ ଦିନ',
  operatorAnalyticsHalfDays: 'ଅଧା ଦିନ',
  operatorAnalyticsHmr: 'ମୋଟ HMR',
  operatorAnalyticsJobs: 'ସମ୍ପୂର୍ଣ୍ଣ କାମ',
  operatorAnalyticsIssues: 'ରିପୋର୍ଟ ହୋଇଥିବା ସମସ୍ୟା',
  operatorAnalyticsAvgHmr: 'ହାରାହାରି HMR/ଦିନ',
  operatorAnalyticsMonthlyTrend: 'ମାସିକ କାମ ପ୍ରବୃତ୍ତି',
  operatorAnalyticsIssueBreakdown: 'ପ୍ରକାର ଅନୁଯାୟୀ ସମସ୍ୟା',
  operatorAnalyticsRecentJobs: 'ସାମ୍ପ୍ରତିକ କାମ',
  operatorAnalyticsNoData: 'ଏହି ଅବଧିରେ କାମ ରେକର୍ଡ ନାହିଁ',
  adminServiceAlertsTitle: 'ସେବା ସତର୍କତା',
  adminServiceAllOk: 'ସମସ୍ତ ମେସିନର ସେବା ରେକର୍ଡ ଅପ-ଟୁ-ଡେଟ୍ ✅',
  adminServiceNoRecord: 'କୌଣସି ରେକର୍ଡ ନାହିଁ',
  adminServiceColLastService: 'ଶେଷ ସେବା',
  adminServiceColNextDue: 'ପରବର୍ତ୍ତୀ Due',
  adminServiceColServiceStatus: 'ସେବା ସ୍ଥିତି',
  adminMachinesColMinHrs: 'ସୁନ୍ନ ଘଣ୍ଟା',
  adminMachinesColRateDay: 'ଦର/ଦିନ',
  adminClientName: 'ଗ୍ରାହକଙ୍କ ନାମ',
  adminOwnerName: 'ମାଲିକଙ୍କ ନାମ',
  adminPayoutWallet: 'ପେଆଉଟ୍ ୱାଲେଟ୍',
  adminFooterMachines: 'ଯନ୍ତ୍ର',
  adminFooterClients: 'ଗ୍ରାହକ',
  adminFooterOwners: 'ମାଲିକ',
  auditSeverityCritical: 'ଗୁରୁତର',
  auditSeverityHigh: 'ଉଚ୍ଚ',
  auditSeverityMedium: 'ମଧ୍ୟମ',
  auditSeverityNormal: 'ସାଧାରଣ',
  auditCopyEvent: 'ଇଭେଣ୍ଟ କପି କରନ୍ତୁ',
  auditViewDetails: 'ବିବରଣୀ ଦେଖନ୍ତୁ',
  auditHideDetails: 'ବିବରଣୀ ଲୁଚାନ୍ତୁ',
  auditCopyJson: 'JSON କପି କରନ୍ତୁ',
  auditNoLogs: 'କୌଣସି ଅଡିଟ୍ ଲଗ୍ ନାହିଁ',
  auditIntroBanner: 'ଲଗଇନ୍, ଆଡମିନ୍ କାର୍ଯ୍ୟ ଏବଂ ସୁରକ୍ଷା ଘଟଣା। ଫିଲ୍ଟର୍ ଲୋଡ୍ କରାଯାଇଥିବା ଫଳାଫଳରେ ପ୍ରଯୋଜ୍ୟ; ପୁରୁଣା ଧାଡ଼ିଗୁଡ଼ିକ ପାଇଁ ଅଧିକ ଲୋଡ୍ କରନ୍ତୁ।',
  auditLoaded: 'ଲୋଡ୍ କରାଯାଇଛି',
  auditMoreAvailable: 'ଅଧିକ ଉପଲବ୍ଧ',
  auditEndOfList: 'ତାଲିକା ଶେଷ',
  auditFilterActive: 'ଫିଲ୍ଟର୍ ସକ୍ରିୟ',
  auditFiltersActive: 'ଫିଲ୍ଟର୍ ସକ୍ରିୟ',
  auditSeverityBreakdown: 'ଗମ୍ଭୀରତା ବିଭାଜନ (ବର୍ତ୍ତମାନ ତାଲିକା)',
  auditPressSlash: 'କାର୍ଯ୍ୟ ଫିଲ୍ଟର୍‌ରେ ଫୋକସ୍ କରିବାକୁ / ଦବାନ୍ତୁ',
  auditFilters: 'ଫିଲ୍ଟର୍',
  auditFilterActionPlaceholder: 'Filter action (e.g. dlq_retry)',
  auditFilterActorPlaceholder: 'Filter actorId',
  auditAllRoles: 'ସମସ୍ତ ଭୂମିକା',
  auditFilterEntityPlaceholder: 'Entity type (e.g. dead_letter_queue)',
  auditFilterMetaPlaceholder: 'ମେଟାଡାଟା JSON ଖୋଜନ୍ତୁ',
  auditFilterFromPlaceholder: 'ଆରମ୍ଭ ତାରିଖ ଏବଂ ସମୟ',
  auditFilterToPlaceholder: 'ଶେଷ ତାରିଖ ଏବଂ ସମୟ',
  audit24h: '24h',
  audit7d: '7d',
  auditTimezonePrefix: 'ସମୟ କ୍ଷେତ୍ର:',
  auditTimezoneSuffix: '(ସ୍ଥାନୀୟ)',
  auditHideCsvOptions: 'CSV କଲମ୍ ବିକଳ୍ପ ଲୁଚାନ୍ତୁ',
  auditShowCsvOptions: 'CSV କଲମ୍ ବିକଳ୍ପ ଦେଖାନ୍ତୁ',
  auditCsvColCreatedAt: 'ସୃଷ୍ଟି ସମୟ',
  auditCsvColAction: 'କାର୍ଯ୍ୟ',
  auditCsvColActorId: 'Actor ID',
  auditCsvColActorRole: 'Actor Role',
  auditCsvColEntityType: 'Entity Type',
  auditCsvColEntityId: 'Entity ID',
  auditCsvColMetadata: 'ମେଟାଡାଟା',
  auditFooterLoaded: 'ଲୋଡ୍ କରାଯାଇଛି',
  auditFooterLogs: 'ଅଡିଟ୍ ଲଗ୍',
  auditFooterMoreAvailable: '(ଅଧିକ ଉପଲବ୍ଧ)',
  auditFooterAllLoaded: '(ସମସ୍ତ ଲୋଡ୍ କରାଯାଇଛି)',
  auditActor: 'ଅଭିନେତା',
  auditEntity: 'ସଂସ୍ଥା',
  auditEventLog: 'ଇଭେଣ୍ଟ ଲଗ୍',
  notificationCenter: 'ବିଜ୍ଞପ୍ତି',
  notifChannelAll: 'ସବୁ',
  notifChannelWhatsapp: 'WhatsApp',
  notifChannelEmail: 'ଇମେଲ',
  notifChannelPush: 'ପୁଶ',
  notifChannelSms: 'SMS',
  notifStatusSent: 'ପଠାଗଲା',
  notifStatusFailed: 'ବିଫଳ',
  notifStatusPending: 'ବିଚାରାଧୀନ',
  notifEmpty: 'ଏପର୍ଯ୍ୟନ୍ତ କିଛି ବିଜ୍ଞପ୍ତି ନାହିଁ',
  notifLoadMore: 'ଅଧିକ ଲୋଡ୍ କରନ୍ତୁ',
  adminNotifLog: 'ବିଜ୍ଞପ୍ତି ଲଗ',
  adminNotifColUser: 'ବ୍ୟବହାରକାରୀ',
  adminNotifColRole: 'ଭୂମିକା',
  adminNotifNoData: 'ଏପର୍ଯ୍ୟନ୍ତ କିଛି ବିଜ୍ଞପ୍ତି ଲଗ ହୋଇନାହିଁ',
  etaOwnerApproval: 'ମାଲିକଙ୍କ ଅନୁମୋଦନ ଅପେକ୍ଷା',
  etaWorkInProgress: 'ଅନୁମାନିତ ସମାପ୍ତି',
  etaPaymentDeadline: 'ପେମେଣ୍ଟ ନିଶ୍ଚିତକରଣ ସମୟସୀମା',
  etaWorkCompleted: 'କାମ ସମାପ୍ତ',
  etaDisputeReview: 'DE ଦଳ ବିବାଦ ସମୀକ୍ଷା କରୁଛି',
  etaMinutesRemaining: '{n} ମିନିଟ ବାକି',
  etaHoursRemaining: '{n} ଘଣ୍ଟା ବାକି',
  txRecharge: 'ୱାଲେଟ୍ ରିଚାର୍ଜ',
  txBookingAdvance: 'ବୁକିଂ ଆଗତ',
  txBookingPayment: 'ବୁକିଂ ପେମେଣ୍ଟ',
  txSettlement: 'ସେଟଲମେଣ୍ଟ',
  txRefund: 'ରିଫଣ୍ଡ',
  txPenalty: 'ଜରିମାନା',
  txCommission: 'କମିସନ',
  tacTitle: "नियम और शर्तें",
  tacPrivacy: "गोपनीयता नीति",
  tacRefund: "रिफंड नीति",
  tacCancellation: "रद्दीकरण नीति",
  tacServiceDelivery: "सेवा वितरण नीति",
  tacIntro: "बुकिंग से पहले हमारी नीतियाँ देखें",
  tacBannerTitle: "नियम अपडेट उपलब्ध",
  tacBannerOpen: "नियम खोलें",
  tacBannerAgree: "मैंने पढ़ लिया है और सहमत हूँ",
  tacBannerLater: "बाद में",
  clientPoliciesTitle: "ग्राहक नीतियाँ",
  machineGroupAvailable: "उपलब्ध",
  machineGroupBusy: "व्यस्त",
  dewateringReferral: "डीवाटरिंग (पंप) सेवा चाहिए? MachineOS जल्द पंप ठेकेदार सेवाएँ जोड़ेगा। रेफरल के लिए सपोर्ट से संपर्क करें।",
  noActiveWork: "इस महीने कोई सक्रिय कार्य नहीं",
  accountTab: "ଆକାଉଣ୍ଟ",
  recentActivity: "ସାମ୍ପ୍ରତିକ କାର୍ଯ୍ୟକଳାପ",
  goodMorning: "ଶୁଭ ସକାଳ",
  goodAfternoon: "ଶୁଭ ମଧ୍ୟାହ୍ନ",
  goodEvening: "ଶୁଭ ସନ୍ଧ୍ୟା",
  thisMonthEarned: 'This month earned',
  standardBookings: 'Standard bookings',
  activeContracts: 'Active contracts',
  contractsOngoing: 'Contracts ongoing',
  noActiveContracts: 'None this period',
  quotationsPending: 'Quotations awaiting reply',
  allUpToDate: 'All bookings up to date',
  noBookingsInPeriod: 'No bookings in this period',
  contractBookings: 'Contract bookings',
  noContractsInPeriod: 'No contracts in this period',
  mobilizationReleased: 'Mobilization released',
  pendingRelease: 'Pending release',
  raBills: 'RA-bills',
  disputed: 'Disputed',
  all: 'All',
  completed: 'Completed',
};
